import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { TranslateService } from '@ngx-translate/core';
import { environment } from './environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, ConfirmDialog],
  template: `
    <router-outlet />
    <p-toast />
    <p-confirmdialog />
  `,
})
export class App {
  private static readonly LANG_STORAGE_KEY = 'axxyl-lang';
  private static readonly RTL_LANGS = ['ar'];

  constructor() {
    const translate = inject(TranslateService);
    translate.addLangs(environment.supportedLangs);
    translate.setDefaultLang(environment.defaultLang);

    const supported = environment.supportedLangs;
    const saved = localStorage.getItem(App.LANG_STORAGE_KEY);
    const browserLang = navigator.language?.split('-')[0];
    const lang = (saved && supported.includes(saved)) ? saved
      : (browserLang && supported.includes(browserLang)) ? browserLang
      : environment.defaultLang;

    translate.use(lang);
    this.applyDir(lang);

    translate.onLangChange.subscribe(e => {
      localStorage.setItem(App.LANG_STORAGE_KEY, e.lang);
      this.applyDir(e.lang);
    });
  }

  private applyDir(lang: string): void {
    const dir = App.RTL_LANGS.includes(lang) ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
  }
}
